<template>
  <div class="app has-header">

    <!-- main view -->
    <template v-if="!loading">
      <div class="header main">
        <div class="align-left">
          <strong v-if="title">{{ title }}</strong>
          <slot name="header-left"></slot>
        </div>
        <div class="align-middle">
          <headerbuttonstack :state="headerButtons || []"/>
          <slot name="header-middle"></slot>
        </div>
        <div class="align-right">
          <slot name="header-right"></slot>
        </div>
      </div>

        <div class="report-page-container">
            <div class="flex-col">
                <div class="employees-container" v-if="$slots['employee-list']">
                    <slot name="employee-list"></slot>
                </div>
            </div>
            <div class="flex-col">
                <div class="settings-container" v-if="$slots['report-settings']">
                    <slot name="report-settings"></slot>
                </div>
                <div class="reports-container" v-if="$slots['report-list']">
                    <slot name="report-list"></slot>
                </div>
                <slot></slot>
            </div>
        </div>
    </template>

    <employeeworkbalancecreation ref="employeeworkbalancecreation" :loading="loading" :loading-text="loadingText"/>
  </div>
</template>

<script>
import employeeworkbalancecreation from '@/components/workbalancecontext/EmployeeWorkBalanceCreation';

export default {
  name: 'md-report-layout',
  components: {
    employeeworkbalancecreation,
  },
  props: {
    title: String,
    headerButtons: Object,
    loading: {
      type: Boolean,
      default: () => false,
    },
    loadingText: {
      type: String,
      default: () => '',
    },
  },
}
</script>

<style scoped>
.report-page-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    height: calc(100% - var(--header-height));
    /*noinspection CssOverwrittenProperties*/
    padding-top: 60px;
    /*noinspection CssOverwrittenProperties*/
    padding-top: var(--header-height);
}

.flex-col {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 1rem;
}

.employees-container {
    width: 25vw;
    height: 100%;
}

.settings-container {
    width: 70vw;
}

.reports-container {
    width: 70vw;
    min-height: 8rem;
}

.reports-list {
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
}

</style>
